<div class="row-field">
  <div class="row">
    <div class="col-md-12">
      <h3>Artikel</h3>
    </div>
  </div>

  <!-- Null Value -->
  <div class="row">
    @if (article) {
      <div class="col-md-12 min">
        <a uiSref="a.article.workflow.overview" [uiParams]="{id: article.oa_nr}"
          target="_blank"
          ngbTooltip="Artikelseite in neuem Fenster öffnen">
          @if (article.sds_nr) {
            <h4>SDS-Nr.: {{ article.sds_nr }}</h4>
          }
          @if (!article.sds_nr) {
            <h4>0A-Nr.: {{ article.oa_nr }}</h4>
          }
        </a>
        @if (article.sds_nr) {
          <span>0A-Nr.: {{ article.sds_nr }}</span>
        }
      </div>
    }

    @if (!article) {
      <div class="col-md-12 min">
        <h4>kein Artikel ausgewählt</h4>
      </div>
    }

  </div>

  <div class="row">
    <div class="col-md-12 text-left">

      <div class="btn-group">
        <button type="button" class="btn btn-default btn-sm" (click)="switchArticle()" [disabled]="formDisabled">
          Bearbeiten
        </button>
      </div>

    </div>
  </div>
</div>
